import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const pricebookCardsViewAttributeOptionsByType: Record<
    PricebookType,
    CardsViewAttributeOption<PricebookItem>[]
> = {
    service: [
        { name: "default_price", label: "Default Rate" },
        { name: "default_is_taxable", label: "Taxability" },
        { name: "default_job_duration", label: "Duration" },
        { name: "last_modified_at", label: "Last Modified" },
        { name: "labels", label: "Labels" },
    ],
    part: [
        { name: "default_price", label: "Price" },
        { name: "track_inventory", label: "Inventory" },
        { name: "default_is_taxable", label: "Taxability" },
        { name: "last_modified_at", label: "Last Modified" },
        { name: "labels", label: "Labels" },
        { name: "lowest_inventory_status", label: "Inventory Status" },
        { name: "inventory_value", label: "Inventory Value" },
        { name: "total_quantity_on_order", label: "Quantity On Order" },
    ],
    other: [
        { name: "default_price", label: "Price" },
        { name: "default_is_taxable", label: "Taxability" },
        { name: "last_modified_at", label: "Last Modified" },
        { name: "labels", label: "Labels" },
    ],
    discount: [
        { name: "default_price", label: "Discount" },
        { name: "last_modified_at", label: "Last Modified" },
        { name: "labels", label: "Labels" },
    ],
    tax: [
        { name: "default_price", label: "Default Tax Rate" },
        { name: "last_modified_at", label: "Last Modified" },
        { name: "labels", label: "Labels" },
    ],
}

export const pricebookCardsViewSortOptionsByType: Record<PricebookType, CardsViewSortOption<PricebookItem>[]> = {
    service: [
        { name: "description", label: "Short Description" },
        { name: "status_label", label: "State" },
        { name: "subtype_label", label: "Subtype" },
        { name: "cost", label: "Cost" },
        { name: "default_price", label: "Rate" },
        { name: "default_job_duration", label: "Est. Duration" },
        { name: "last_modified_at", label: "Last Modified" },
    ],
    part: [
        { name: "description", label: "Short Description" },
        { name: "status_label", label: "State" },
        { name: "subtype_label", label: "Subtype" },
        { name: "manufacturer", label: "MFG" },
        { name: "part_number", label: "MFG Part #" },
        { name: "cost", label: "Cost" },
        { name: "default_price", label: "Price" },
        { name: "lowest_inventory_status", label: "Stock" },
        { name: "inventory_level", label: "Levels" },
        { name: "last_modified_at", label: "Last Modified" },
    ],
    other: [
        { name: "description", label: "Short Description" },
        { name: "status_label", label: "State" },
        { name: "subtype_label", label: "Subtype" },
        { name: "cost", label: "Cost" },
        { name: "default_price", label: "Price" },
        { name: "last_modified_at", label: "Last Modified" },
    ],
    discount: [
        { name: "description", label: "Short Description" },
        { name: "status_label", label: "State" },
        { name: "subtype_label", label: "Subtype" },
        { name: "default_price", label: "Discount" },
        { name: "last_modified_at", label: "Last Modified" },
    ],
    tax: [
        { name: "description", label: "Short Description" },
        { name: "status_label", label: "State" },
        { name: "default_price", label: "Tax Rate" },
        { name: "last_modified_at", label: "Last Modified" },
    ],
}
